import LienItem from "./LienItem";

export default function LienDetails() {

    return <>
        <LienItem/>
    </>
}